<template>

    <section
        id="hero"
        class="hero"
    >

        <img
            class="hero__image"
            :src="'home_hero' | staticImg"
            :alt="'home_hero' | staticTitle"
        >

        <div class="hero__overlay"></div>

        <div class="hero__container">

            <div class="hero__content">

                <h1 class="hero__title">

                    {{ 'home_hero_title' | staticTitle }}

                    <br>

                    <span>
                        {{ 'home_hero_title_accent' | staticTitle }}
                    </span>

                </h1>

                <p class="hero__text">
                    {{ 'home_hero' | staticContent }}
                </p>

                <div class="hero__buttons">

                    <router-link
                        :to="{ path: '/', hash: '#contact' }"
                        class="hero__button hero__button--primary"
                    >
                        {{ 'home_hero_primary_button' | staticTitle }}
                    </router-link>

                    <router-link
                        to="/sermons"
                        class="hero__button hero__button--secondary"
                    >
                        {{ 'home_hero_secondary_button' | staticTitle }}
                    </router-link>
                </div>

            </div>

        </div>

    </section>

</template>

<script>
export default {
    name: 'HomeHero'
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;500;600;700&display=swap');

.hero {
    position: relative;

    width: 100%;
    min-height: 700px;
    height: 82vh;

    overflow: hidden;

    padding-top: 74px;

    &__image {
        position: absolute;

        top: 0;
        right: 0;
        bottom: 0;
        left: 0;

        width: 100%;
        height: 100%;

        object-fit: cover;
        object-position: 62% center;
    }

    &__overlay {
        position: absolute;

        top: 0;
        right: 0;
        bottom: 0;
        left: 0;

        background: linear-gradient(
            90deg,
            rgba(0, 0, 0, .82) 0%,
            rgba(0, 0, 0, .56) 34%,
            rgba(0, 0, 0, .22) 68%,
            rgba(0, 0, 0, .10) 100%
        );
    }

    &__container {
        position: relative;

        width: 100%;
        height: 100%;

        padding: 0 20px;

        display: flex;
        align-items: center;

        z-index: 2;
    }

    &__content {
        width: 100%;
        max-width: 620px;

        margin-top: 20px;
    }

    &__title {
        max-width: 620px;

        margin: 0 0 24px;

        color: var(--white);

        font-family: 'Cormorant Garamond', serif;

        font-size: clamp(2.4rem, 9vw, 3.4rem);
        font-weight: 700;

        line-height: .95;

        letter-spacing: -.02em;

        text-transform: uppercase;

        span {
            display: block;

            margin-top: 8px;

            color: var(--primary);

            font-size: .92em;
            line-height: .92;
        }
    }

    &__text {
        max-width: 430px;

        margin: 0 0 36px;

        color: var(--secondary);

        font-size: 1rem;

        line-height: 1.55;
    }

    &__buttons {
        display: flex;
        flex-direction: column;

        gap: 10px;
    }

    &__button {
        min-height: 48px;

        display: flex;
        align-items: center;
        justify-content: center;

        padding: 10px 16px;

        border-radius: 4px;

        font-size: .8rem;
        font-weight: 700;

        text-align: center;
        text-transform: uppercase;
        text-decoration: none;

        transition:
            background .3s ease,
            color .3s ease,
            border-color .3s ease,
            transform .3s ease;

        &:hover {
            transform: translateY(-2px);
        }

        &--primary {
            background: var(--primary);
            color: var(--secondary);

            &:hover {
                background: var(--primary-hover);
            }
        }

        &--secondary {
            color: var(--secondary);

            border: 2px solid rgba(255, 255, 255, .75);

            &:hover {
                background: var(--background);
                color: var(--text);

                border-color: var(--background);
            }
        }
    }
}

@media (min-width: 768px) {
    .hero {
        height: 82vh;
        min-height: 720px;

        &__image {
            object-position: center center;
        }

        &__container {
            padding: 0 50px;
        }

        &__content {
            max-width: 700px;

            margin-top: 0;
        }

        &__title {
            max-width: 700px;

            font-size: clamp(3.4rem, 6vw, 4.4rem);

            line-height: .92;

            span {
                margin-top: 10px;

                font-size: .88em;
            }
        }

        &__text {
            max-width: 500px;

            font-size: 1.05rem;
        }

        &__buttons {
            flex-direction: row;

            gap: 16px;
        }

        &__button {
            width: 220px;
            min-height: 52px;

            font-size: .9rem;
        }
    }
}

@media (min-width: 1024px) {
    .hero {
        &__container {
            max-width: 1400px;

            margin: 0 auto;

            padding: 0 60px;
        }

        &__content {
            max-width: 760px;
        }

        &__title {
            max-width: 760px;

            font-size: clamp(4rem, 5vw, 4.8rem);

            line-height: .9;

            span {
                font-size: .86em;
            }
        }

        &__text {
            max-width: 520px;

            font-size: 1.15rem;
        }
    }
}

@media (min-width: 1400px) {
    .hero {
        &__content {
            max-width: 820px;
        }

        &__title {
            max-width: 820px;

            font-size: 5rem;
        }
    }
}
</style>